import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import { BehaviorSubject } from 'rxjs';
import { MatDialog, MatSnackBar } from '@angular/material';
// import { CustdispositionService } from '../setting.service';

@Component({
  selector: 'app-customdisposition1',
  templateUrl: './customdisposition1.component.html',
  styleUrls: ['./customdisposition1.component.css']
})
export class Customdisposition1Component {

  private __data = new BehaviorSubject<number>(1);
  public csolution = this.__data.asObservable();
  public campname: string;
  public cresult: number;
  public objectionData = [];
  @Input() ankur = new EventEmitter<any>();
  @Input() ankur2 = new EventEmitter<any>();
  @Input() automation = new EventEmitter<any>();

  @Input() fieldArray: Array<any> = [];
  @Output() DeleteDispo = new EventEmitter();
  @Output() AddFieldValue = new EventEmitter<any>();
  @Output() DeleteFieldValue = new EventEmitter<any>();
  @Output() OnKeyBlur = new EventEmitter<any>();
  @Output() OnSubmit = new EventEmitter<any>();
  @Output() OnUpdate = new EventEmitter<any>();
  @Output() GetStatusDis: EventEmitter<any> = new EventEmitter();
  @Input() enabled: EventEmitter<boolean> = new EventEmitter();
  @Input() felds_status: EventEmitter<boolean> = new EventEmitter();

  @Output() getValue: EventEmitter<boolean> = new EventEmitter();
  @Output() ChangeColor = new EventEmitter<any>();
  @Output() OnAddcheckBox = new EventEmitter<any>();
  @Output() Start = new EventEmitter<any>();
  @Output() Stop = new EventEmitter<any>();

  @Input() disabled: boolean;


  /** To handle the sale status */
  @Input() is_sale: EventEmitter<boolean> = new EventEmitter(true);

  @Output() Sale_Start = new EventEmitter<any>();
  @Output() Sale_Stop = new EventEmitter<any>();

  public iseditdispo: boolean = true;
  public menuright: boolean = true;
  public currcolor: string = 'dblue';
  public isupdate: boolean = false;
  isLoading: boolean;
  checked: boolean = false;
  @Input() dispo: boolean;

  dialerdata: any;

  @Output() SaveAutomation = new EventEmitter();

  constructor(protected router: Router, protected msg: MatSnackBar, public dialog: MatDialog,) {
    // super(msg);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.csolution.subscribe(result => {
      console.log("Result" + result);
      this.cresult = result;
    });
    console.log(this.automation)

  }

  getMessage(message: any, i) {
    console.log(message);
    console.log(i)

    if (message === true) {
      this.GetStatusDis.emit({ status: true, id: i });
    } else {
      this.GetStatusDis.emit(false);
    }
  }

  getMessageinActive(message: any, i) {
    console.log(message)
    console.log(i);

    if (message === true) {
      this.GetStatusDis.emit({ status: false, id: i });
    } else {
      this.GetStatusDis.emit(true);
    }
  }

  deleteDispo(id) {
    if (!confirm("Are you sure, You want to delete this Disposition!")) {
      return false
    }
    console.log("Id::", id);
    this.DeleteDispo.emit(id);
  }

  deleteFieldValue(index) {
    console.log(index);
    this.DeleteFieldValue.emit(index);
  }

  onKeyBlur(event: any, index: number, obtype: number) {
    console.log(event, index);
    console.log(event.target.value);
    this.OnKeyBlur.emit({ event: event.target.value, index: index, obtype: obtype });
  }

  addFieldValue(index: any) {
    this.AddFieldValue.emit(index);
    console.log(this.fieldArray)
  }

  onSubmit(e) {
    console.log(e.target.value);
    console.log("globle objection:::", this.objectionData);
    console.log(this.cresult);
    this.OnSubmit.emit(this.cresult);
  }

  onUpdate(e) {
    console.log(e.target.value);
    console.log("globle objection:::", this.objectionData);
    console.log(this.cresult);
    this.OnUpdate.emit(this.cresult);
  }

  changeColor(ctype: string, index: number) {
    console.log("Current Color ::" + ctype);
    this.ChangeColor.emit({ ctype: ctype, index: index });
  }

  onAddcheckBox(e, index: number) {
    console.log(e);
    this.OnAddcheckBox.emit({ e: e.target.checked, index });
  }


  /**
   * To handle the statuses
   */
  start(index: number, state: number) {
    console.log("Current Index ::" + index);
    this.Start.emit({ index: index, state: state });
  }

  stop(index: number, state: number) {
    console.log("Current Index ::" + index);
    this.Stop.emit({ index: index, state: state });
  }


  /**
   * To handle the sales statuses
   */
  sale_start(index: number, state: number) {
    console.log("Current Index Sale::" + index + ":" + state);
    this.Sale_Start.emit({ index: index, is_sale: state });
  }

  sale_stop(index: number, state: number) {
    console.log("Current Index Sale ::" + index + ":" + state);
    this.Sale_Stop.emit({ index: index, is_sale: state });
  }

  randomcodegenerator() {
    let encode = window.btoa("kuldip");
    let idencode = window.btoa("1");
    // 'MQ=='
    let text = encode+idencode+encode;
    console.log(text)
    const myArray = text.split(encode);
    console.log(window.atob(myArray[1]))
  }

  saveAutomation(e: any, id: any): any {
    console.log("e::", e)
    console.log("rowdata::", id)
    
    this.SaveAutomation.emit({
      id_automation: e.target.value,
      id_disposition: id
    })
  }

}